import { MEDIA_TYPE_LOOKUP, STATUS_LOOKUP } from './constants'
import type { TableMapModel } from './types'

export const informationTableMap: TableMapModel[] = [
  { header: 'Media Number', keyName: 'mediaNumber' },
  {
    header: 'Media Type',
    keyName: 'mediaType',
    transform: { type: 'lookup', map: MEDIA_TYPE_LOOKUP },
  },
  { header: 'Title', keyName: 'title' },
  {
    header: 'Product Model',
    keyName: 'engineModels',
    valuePath: 'description',
  },
  {
    header: 'Engine Market',
    keyName: 'engineMarkets',
    valuePath: 'description',
  },
  {
    header: 'Sub-Industry',
    keyName: 'subIndustries',
    valuePath: 'description',
  },
  { header: 'Category', keyName: 'categories', valuePath: 'description' },
  {
    header: 'Product Type',
    keyName: 'productTypes',
    valuePath: 'description',
  },
  {
    header: 'Emission Tier',
    keyName: 'emissionTiers',
    valuePath: 'description',
  },
  {
    header: 'Target Region',
    keyName: 'regions',
    valuePath: 'description',
  },
  { header: 'Duty', keyName: 'duties', valuePath: 'description' },
  { header: 'Keywords', keyName: 'keywords' },
  { header: 'Language', keyName: 'languages', valuePath: 'description' },
  { header: 'Long Description', keyName: 'longDescription' },
  { header: 'Restrictions', keyName: 'restrictions' },
  {
    header: 'Media Status',
    keyName: 'status',
    transform: { type: 'lookup', map: STATUS_LOOKUP },
  },
  {
    header: 'Last Modified Date',
    keyName: 'dateModified',
    transform: { type: 'date' },
  },
  { header: 'Fuel Type', keyName: 'fuelTypes', valuePath: 'description' },
  {
    header: 'Frequency',
    keyName: 'frequencies',
    valuePath: 'description',
  },
  { header: 'RPM', keyName: 'rpms', valuePath: 'description' },
  { header: 'Voltage', keyName: 'voltages', valuePath: 'description' },
  { header: 'Rating kVA', keyName: 'ratings.kva' },
  { header: 'Rating bkW', keyName: 'ratings.bkw' },
  { header: 'Rating ekW', keyName: 'ratings.ekw' },
  { header: 'Rating mhp', keyName: 'ratings.mhp' },
]

export const informationForProvidersTableMap: TableMapModel[] = [
  { header: 'Product Id', keyName: 'productIds', valuePath: 'prodId' },
  { header: 'Support Name', keyName: 'support.name' },
  { header: 'Support Phone', keyName: 'support.phone' },
  { header: 'Support Email', keyName: 'support.email' },
  { header: 'Provider Name', keyName: 'provider.name' },
  { header: 'Provider Phone', keyName: 'provider.phone' },
  { header: 'Provider Email', keyName: 'provider.email' },
  { header: 'Last Modified By', keyName: 'modifiedByName' },
  {
    header: 'Application',
    keyName: 'applications',
    valuePath: 'description',
  },
  { header: 'Includes Clipping Art', keyName: 'clipPath' },
  {
    header: 'Performance Number',
    keyName: 'performanceRevisionNumbers',
    valuePath: 'performanceNumber',
  },
  { header: 'Secure Date', keyName: 'secureDate', transform: { type: 'date' } },
  { header: 'Source', keyName: 'sources', valuePath: 'description' },
  {
    header: 'Affiliation Codes',
    keyName: 'affiliations',
    valuePath: 'code3',
  },
  {
    header: 'Feature Code',
    keyName: 'xMetadata',
    xMeta: { kind: 'single', valueCode: 'FCTEXT' },
  },
  {
    header: 'Country of Use',
    keyName: 'xMetadata',
    xMeta: { kind: 'startsWith', valueCode: 'FUI' },
  },
  {
    header: 'Excitation',
    keyName: 'xMetadata',
    xMeta: { kind: 'startsWith', valueCode: 'EXCIT' },
  },
  {
    header: 'Generator Arrangement',
    keyName: 'xMetadata',
    xMeta: { kind: 'startsWith', valueCode: 'GENARGTXT' },
  },
  {
    header: 'Configurable Sales Model',
    keyName: 'xMetadata',
    xMeta: { kind: 'startsWith', valueCode: 'CSMTEXT' },
  },
  {
    header: 'CAT.com Product Technical Information',
    keyName: 'xMetadata',
    xMeta: { kind: 'boolean', valueCode: 'CATTRUE' },
  },
  {
    header: 'Technical Information Portal (TIP)',
    keyName: 'xMetadata',
    xMeta: { kind: 'boolean', valueCode: 'TIP' },
  },
  {
    header: 'Customer Solutions Quoter (CSQ)',
    keyName: 'xMetadata',
    xMeta: { kind: 'boolean', valueCode: 'CSQTRUE' },
  },
  {
    header: 'Gas Engine Rating Pro (GERP)',
    keyName: 'xMetadata',
    xMeta: { kind: 'boolean', valueCode: 'GERP' },
  },
  {
    header: 'Electric Power Spec Sizer',
    keyName: 'xMetadata',
    xMeta: { kind: 'boolean', valueCode: 'EPSSTRUE' },
  },
  {
    header: 'Media Applies To',
    keyName: 'xMetadata',
    xMeta: { kind: 'radio', valueCode: 'APPLYTO' },
  },
  {
    header: 'Power.cat.com',
    keyName: 'xMetadata',
    xMeta: { kind: 'boolean', valueCode: 'VSPTRUE' },
  },
]
